import { ShowButton, TextField, useTable } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { Space, Table } from "antd";

import { AppImagePreview } from "../../../components";
import { errorNotification } from "../../../helpers";
import { PlayerAwardType } from "../Lib";
import { AwardsDelete } from "../Awards-Delete/Awards-Delete";
import s from "../../News/News-List/All-News/All-News.module.scss";

export const AwardTypesList = () => {
  const { push } = useNavigation();

  const { tableProps } = useTable<PlayerAwardType>({
    dataProviderName: "awardTypesDataProvider",
    resource: "award-types",
    syncWithLocation: false,
    queryOptions: {
      enabled: true,
    },
    ...errorNotification(),
  });

  const handleNavigateToAwardType = (id: string | number) => {
    push(`/award-types/${id}`);
  };

  return (
    <Table
      {...tableProps}
      scroll={{ x: 1200 }}
      rowKey="id"
      locale={{
        emptyText: <div style={{ margin: 56 }}>Типы наград отсутствуют</div>,
      }}
      showSorterTooltip={false}
      pagination={false}
    >
      <Table.Column<PlayerAwardType>
        dataIndex={"imageUrl"}
        width={260}
        key="imageUrl"
        title={"Изображение"}
        render={(value) => (
          <AppImagePreview
            imageURL={value}
            useS3={Boolean(value) && !value.startsWith("http")}
            sharedStyles={s.imageUrl}
          />
        )}
      />
      <Table.Column<PlayerAwardType>
        width={220}
        dataIndex={"name"}
        key="name"
        title="Служебное название"
        render={(_, record) => <TextField value={record.name} />}
      />
      <Table.Column<PlayerAwardType>
        width={340}
        dataIndex={"displayName"}
        key="displayName"
        title="Название для вывода"
        render={(_, record) => <TextField value={record.displayName} />}
      />
      <Table.Column<PlayerAwardType>
        width={260}
        fixed={"right"}
        key="actions"
        title="Действия"
        render={(_, record) => (
          <Space size={8} direction="vertical" style={{ width: "100%" }}>
            <ShowButton
              onClick={() => handleNavigateToAwardType(record.id)}
              size={"small"}
              block
            >
              Смотреть / Редактировать
            </ShowButton>
            <AwardsDelete
              id={Number(record.id)}
              name={record.displayName || record.name}
              dataProviderName="awardTypesDataProvider"
              resource="award-types"
              redirectPath="/award-types"
              entityAccusative="тип награды"
            />
          </Space>
        )}
      />
    </Table>
  );
};
